<template>
    <el-row>
        <el-col :span="24">
            <h2>Select payment method</h2>
        </el-col>
        <el-col :span="24" v-if="error" style="margin-top:20px">
            <el-alert type="error" show-icon title="Payment gate is unavailable:" :closable="false">
                We encounter problem with payment gate. Please try again later.
            </el-alert>
        </el-col>
        <el-col :span="24" v-else style="margin-top:20px" v-loading="isBusy">
            <el-alert v-if="thankYouMessage" type="success" title="Thank you!" :closable="false">
                Your payment was successfully saved.
            </el-alert>
            <template v-else>
                <div id="dropin-container"></div>
                <el-button type="primary" ref="save-method" style="margin-top:10px">Save Payment Method</el-button>
            </template>
        </el-col>
    </el-row>
</template>

<script>
import btreeDropIn from 'braintree-web-drop-in';

export default {
        props: {
            clientToken: { type: String, required: true },
            hash: { type: String, required: true },
        },
        data() {
            return {
                isBusy: false,
                error: false,
                thankYouMessage: false,
            };
        },
        mounted() {
            btreeDropIn.create({
                authorization: this.clientToken,
                container: '#dropin-container',
            }, (createErr, instance) => {
                if (createErr !== null) {
                    this.error = true;
                    return;
                }

                this.$refs['save-method'].$el.addEventListener('click', () => {
                    instance.requestPaymentMethod(this.savePaymentMethod);
                });
            });
        },
        methods: {
            savePaymentMethod(requestPaymentMethodErr, payload) {
                this.isBusy = true;
                if (requestPaymentMethodErr !== null) {
                    this.$message.error(requestPaymentMethodErr.message);
                    return;
                }

                axios.post(this.url(`payment-gate/${this.hash}/save-payment`), { nonce: payload.nonce })
                     .then(() => this.thankYouMessage = true)
                     .catch(() => this.$message.error('Request could not be finished.'))
                     .finally(() => this.isBusy = false);
            },
        },
    };
</script>

<style scoped>

</style>